import { motion } from 'framer-motion';

export function Polaroid({ imageUrl, rotation = 0 }) {
  return (
    <motion.div
      whileHover={{ scale: 1.05, rotate: 0 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
      style={{ rotate: rotation }}
      className="bg-white p-4 pb-12 shadow-2xl w-52 sm:w-72 md:max-w-sm"
    >
      <div className="aspect-square overflow-hidden bg-gray-100">
        <img 
          src={imageUrl} 
          alt="Story moment" 
          className="w-full h-full object-cover"
        />
      </div>
    </motion.div>
  );
}
